// "How is this calculated" copy shown in the info popovers. Mirrors the metric definitions the back
// documents (README, "Estadísticas de canchas"); keep both in sync when a definition changes.
// Each entry is [title, text].

export const DEFINITIONS = {
  occ: [
    "Ocupación",
    "Horas reservadas ÷ horas disponibles. Las horas disponibles salen del horario de atención de cada cancha, menos los bloqueos (torneos, mantenimiento). Cuentan las reservas confirmadas y las ausencias, porque la cancha quedó tomada. No cuentan las canceladas.",
  ],
  rev: [
    "Ingresos cobrados",
    "Lo cobrado online (seña o total) más lo cobrado en el mostrador con ZocoPDV, menos devoluciones. Se asigna al día del turno, no al día en que entró el pago.",
  ],
  res: [
    "Reservas",
    "Turnos del período con reserva confirmada o marcados como No Show. No incluye canceladas ni reservas vencidas sin pagar.",
  ],
  iph: [
    "Ingreso por hora disponible",
    "Ingresos cobrados ÷ horas disponibles. Sirve para comparar canchas y períodos aunque cambien el horario o la cantidad de canchas.",
  ],
  canc: [
    "Cancelaciones",
    "Reservas canceladas ÷ todas las reservas hechas para turnos del período, canceladas incluidas.",
  ],
  ns: [
    "Ausencias (No Show)",
    "Reservas marcadas como No Show ÷ reservas del período. \"Sin cobrar\" es el saldo que no se cobró de esos turnos, descontando la seña.",
  ],
  unsold: [
    "Horas sin vender",
    "Horas disponibles que nadie reservó. Es la capacidad que todavía podés vender, por ejemplo con precio de hora valle.",
  ],
  lead: [
    "Anticipación promedio",
    "Tiempo promedio entre que se hace la reserva y el comienzo del turno. \"Mismo día\" son las reservas hechas el día del turno.",
  ],
};
